export default __webpack_public_path__ + "static/media/item_1.466fb010.png";